import { render, staticRenderFns } from "./WbsTree.vue?vue&type=template&id=16834774&scoped=true"
import script from "./WbsTree.vue?vue&type=script&lang=js"
export * from "./WbsTree.vue?vue&type=script&lang=js"
import style0 from "./WbsTree.vue?vue&type=style&index=0&id=16834774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16834774",
  null
  
)

export default component.exports